import { AnyAction, Dispatch } from "@reduxjs/toolkit"

// redux
import { setMetaData } from "../../store/slices/metadata.slice"

export const openChat = (dispatch: Dispatch<AnyAction>): boolean => {
  if (typeof window === "undefined") {
    return false
  }

  const chatGuideElement = document.querySelector<HTMLDivElement>(
    "#cxone-guide-container"
  )
  if (chatGuideElement) {
    if (
      typeof chatGuideElement?.style !== "undefined" &&
      chatGuideElement?.style?.display === "none"
    ) {
      chatGuideElement.style.display = "block"
    }
  }

  const button = document.querySelector<HTMLButtonElement>(
    "[data-selector='GUIDE_CHANNEL_BUTTON']"
  )

  if (!button || !button.click) {
    console.warn("Button not found!")
    return false
  }

  button.click()

  dispatch(
    setMetaData({
      shouldShowAIChatbot: false,
      niceChatWindowOpened: true,
      niceChatHasConcluded: false
    })
  )

  setTimeout(() => {
    window.cxone?.("guide", "setButtonSize", "60px")
    window.cxone?.("guide", "setOffsetX", "48px")
    window.cxone?.("guide", "setOffsetY", "48px")
  }, 500)

  return true
}
